import { Deal } from "../../types";
import api from "../../config/Api";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface DealsState {
    deals: Deal[];
    loading: boolean;
    error: string | null | undefined;
    dealCreated: boolean;
    dealUpdated: boolean;
}

const initialState: DealsState = {
    deals: [],
    loading: false,
    error: null,
    dealCreated: false,
    dealUpdated: false,
};


export const createDeal = createAsyncThunk(
    "deals/createDeal",
    async (deal: any, {rejectWithValue}) =>{
        try {
            const response = await api.post("/admin/deals", deal, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
            });
            //console.log("create deal ", response.data);
            return response.data;
        } catch (error: any) {
            //console.log("error ", error.responnse);
            return rejectWithValue(
                error.response?.data?.message || "Failed to create deal"
            );
        }
    }
);


export const getAllDeals = createAsyncThunk(
    "deals/getAllDeals",
    async(_, {rejectWithValue}) => {
        try {
            const response = await api.get("/admin/deals", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
            });
            //console.log("get all deal ", response.data);
            return response.data;
        } catch (error: any) {
            //console.log("error ", error.response);
            return rejectWithValue(error.response.data?.message || "failed to get deal");
        }
    }
);

const dealSlice = createSlice({
    name: "deals",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllDeals.pending, (state) => {
            state.loading = true;
        }); 
        builder.addCase(getAllDeals.fulfilled, (state, action) => {
            state.loading = false;
            state.deals = action.payload;
        }); 
        builder.addCase(getAllDeals.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        }); 

        builder.addCase(createDeal.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createDeal.fulfilled, (state, action) => {
            state.loading = false;
            state.deals.push(action.payload);
        });
        builder.addCase(createDeal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        }); 
    }
});

export default dealSlice.reducer;

